import Vuex from 'vuex'
import Vue from 'vue'
//import { hybridStore } from './modules/hybride'

Vue.use(Vuex)

/**
 * The root store
 * @typedef {Object} RootStore
 * @property {boolean} serverTimeReady Is true when browser is syncrhonized with server datetime
 * @property {(string|null)} pusherConnectionState keep pusher service connection state
 */

/**
 * @type {import('vuex').StoreOptions<RootStore>}
 */
const store = new Vuex.Store({
    /**
     * @returns {RootStore}
     */
    state () {
        return {
            serverTimeReady: false,
            pusherConnectionState: null,
            reloadDataCount: 0
        }
    },

    mutations: {
        timeSynced (state, payload) {
            state.serverTimeReady = payload
        },

        connexionChanged (state, payload) {
            state.pusherConnectionState = payload
        },
        incrementReloadDataCount(state) {
            if (state.reloadDataCount < 4)
            state.reloadDataCount++
        }
    },

    actions: {
        setSynchrinization ({ commit }, payload) {
            commit('timeSynced', payload)
        },

        setPusherConnexionState ({ commit }, payload) {
            commit('connexionChanged', payload)
        },
        dataReloaded({ commit }) {
            commit('incrementReloadDataCount')
        }
    },

    getters: {
        canInitTimers (state) {
            return state.serverTimeReady
        },

        connexionStatus (state) {
            return state.pusherConnectionState
        },
        reloadDataCount (state) {
            return state.reloadDataCount;
        }
    },

    /*modules: {
        hybrid: hybridStore,
    },*/
})

export { store }
